<template>
    <div class="section-offers-and-best-sellers">
		<template v-for="filter in filters">
			<section-offer-day
				:key="filter.id"
				:title="filter.title"
				:products="productsByFilters.filter(p =>
					p.filters.find(f => f === filter.id) === filter.id)"
			></section-offer-day>
		</template>
    </div>
</template>

<script>
import sectionOfferDay from '@/components/market-place/section-offer-day';

export default {
	name: 'section-offers-and-best-sellers',
	components: {
		sectionOfferDay,
	},
	props: {
		filters: {
			default: () => [],
			type: Array,
		},
		productsByFilters: {
			default: () => [],
			type: Array,
		},
	},
};
</script>

<style lang="scss" scoped>
.section-offers-and-best-sellers {
	background-color: white;
	margin: 0 195px;
	padding: 57px 0 85px 0;

	@media (max-width: 936PX) {
		margin: 0 25px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/market-place/section-offers-and-best-sellers.vue